import { render, staticRenderFns } from "./Taller.vue?vue&type=template&id=7d53a494"
import script from "./Taller.vue?vue&type=script&lang=js"
export * from "./Taller.vue?vue&type=script&lang=js"
import style0 from "./Taller.vue?vue&type=style&index=0&id=7d53a494&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports